import { expectedAtlasDimensions, readWebPDimensions, validateManifest, type PetManifest, type ValidationIssue } from "codexpetlab-core";

export interface LocalPetValidation {
  ok: boolean;
  manifest?: PetManifest;
  dimensions?: { width: number; height: number };
  issues: ValidationIssue[];
}

export function validateLocalPetFiles(manifestBytes: Uint8Array, spritesheetBytes: Uint8Array): LocalPetValidation {
  const issues: ValidationIssue[] = [];
  let manifest: PetManifest | undefined;
  try {
    const result = validateManifest(JSON.parse(new TextDecoder().decode(manifestBytes)));
    manifest = result.manifest;
    issues.push(...result.issues);
  } catch {
    issues.push({ code: "manifest.json", message: "pet.json is not valid JSON", severity: "error" });
  }

  let dimensions: { width: number; height: number } | undefined;
  try {
    dimensions = readWebPDimensions(spritesheetBytes);
    if (manifest) {
      const expected = expectedAtlasDimensions();
      if (dimensions.width !== expected.width || dimensions.height !== expected.height) {
        issues.push({ code: "spritesheet.dimensions", message: `expected ${expected.width}x${expected.height}, got ${dimensions.width}x${dimensions.height}`, severity: "error" });
      }
    }
  } catch (error) {
    issues.push({ code: "spritesheet.webp", message: error instanceof Error ? error.message : "invalid WebP spritesheet", severity: "error" });
  }

  issues.push({ code: "visual.qa", message: "Local structural validation does not replace Hatch Pet visual and direction QA", severity: "warning" });
  return { ok: !issues.some((issue) => issue.severity === "error"), manifest, dimensions, issues };
}
